/**
 * @generated SignedSource<<c29968a5e49f69d2fc148e48da737a06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HighLevelBudgetNumbers_company$data = {
  readonly tier: TierType | null;
  readonly id: string;
  readonly currency: string | null;
  readonly " $fragmentType": "HighLevelBudgetNumbers_company";
};
export type HighLevelBudgetNumbers_company$key = {
  readonly " $data"?: HighLevelBudgetNumbers_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighLevelBudgetNumbers_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelBudgetNumbers_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "c77081e59b3f2db9f138a9b36dfaa806";

export default node;
